import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Components/Pages/Home';
import Contant from './Components/Pages/Contant';
import Login from './Components/Admin/Login';
import Dashboard from './Components/Admin/Dashboard';
import Cart from './Components/Cart/Cart';
import ProductDetails from './Components/Pages/ProductDetails';
import { CartProvider } from './Components/Cart/CartContext';
import FilteredProducts from './Components/Pages/FilteredProducts';
import { WishlistProvider } from './Components/Wishlist/WishlistContext';
import Wishlist from './Components/Wishlist/Whshlist';
import Register from './Components/Auth/Register';
import SignUp from './Components/Auth/SignUp';
import ForgotPassword from './Components/Auth/ForgotPassword';
import ResetPassword from './Components/Auth/ResetPassword';
import SearchPage from './Components/Pages/SearchModal';
import Account from './Components/Account/Account';
import CategoryPage from './Components/Pages/CategoryPage';
import Checkout from './Components/Cart/Checkout';
import CheckoutSuccess from './Components/Cart/CheckoutSuccess';
import CheckoutFailure from './Components/Cart/CheckoutFailure';
import AboutUs from './Components/Footer/AboutUs';
import TermsAndConditions from './Components/Footer/TermsAndConditions';
import Returns from './Components/Footer/Returns';
import PrivacyPolicy from './Components/Footer/PrivacyPolicy';
import ShippingTerms from './Components/Footer/ShippingTerms';
import Category from './Components/Pages/Category';
import FilteredProductsCuisines from './Components/Pages/FilteredProductsCuisines';
import OrdersScreen from './Components/Orders/OrderCard';
import WhatsAppChatbot from './Components/WhatsAppChatbot/WhatsAppChatbot';
import AdminProtectedRoute from './Components/Admin/AdminProtectedRoute';


function App() {
  return (
    <CartProvider>
      <WishlistProvider>
        <Router>
          <WhatsAppChatbot />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contant />} />

            {/* <Route path="/register" element={<Register />} /> */}
            {/* <Route path="/signin" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:resetToken" element={<ResetPassword />} /> */}


            <Route path="/adminlogin" element={<Login />} />
            {/* <Route path="/admindashboard" element={<Dashboard />} /> */}

            <Route
              path="/admindashboard"
              element={
                <AdminProtectedRoute>
                  <Dashboard />
                </AdminProtectedRoute>
              }
            />

            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/failure" element={<CheckoutFailure />} />


            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/product/:id" element={<ProductDetails />} />

            <Route path="/food/:superCatName/:subCatName?" element={<FilteredProducts />} />

            <Route path="/foodCuisines/:extraParam" element={<FilteredProductsCuisines />} />

            <Route path="/search" element={<SearchPage />} />

            <Route path="/account" element={<Account />} />

            <Route path="/orders" element={<OrdersScreen />} /> 

            <Route path="/category/:superCatName?" element={<CategoryPage />} />

            {/* <Route path="/category/:superCatName/:subCatName?" element={<CategoryPage />} /> */}



            <Route path="/categories/:name" element={<Category />} />

            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/terms-of-service" element={<TermsAndConditions />} />
            <Route path="/return-policy" element={<Returns />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/shipping-terms" element={<ShippingTerms />} />



          </Routes>
        </Router>
      </WishlistProvider>
    </CartProvider>

  );
}

export default App;
